<div class="modal-content">
  <div class="modal-header bg-primary-100">
    <h5 class="modal-title">Merge Duplicate Educators</h5>
  </div>
  <div class="modal-body position-relative">
    <p>
      You are about to merge two educators into one. This process will <strong>PERMANENTLY</strong>
      transfer all data related to the "duplicate" educator to the "primary" educator. This process
      <strong>CANNOT</strong> be undone. Proceed with caution. Enter the the word "merge" into the box to proceed.
    </p>
    <div class="row">
      <div class="col-6">
        <dl>
          <dt><strong>Primary Educator EIN:</strong></dt>
          <dd>{{ primaryEIN }}</dd>
        </dl>
      </div>
      <div class="col-6">
        <dl>
          <dt><strong>Duplicate Educator EIN:</strong></dt>
          <dd>{{ duplicateEIN }}</dd>
        </dl>
      </div>
    </div>
    <div class="mt-2">
      <label for="merge-input">Enter the word "MERGE" to Proceed</label>
      <input
        type="text"
        class="form-control"
        id="merge-input"
        name="merge-input"
        [(ngModel)]="confirmationInput"
        placeholder='Enter "MERGE" to proceed...'
        [disabled]="mergeInProgress()"
      />
    </div>
    <div class="alert alert-warning mt-3">
      Contact IU prior to merging these educators. All cases related to the "duplicate" educator should be resolved in
      CaseIQ before continuing.
    </div>
    <div formLevelValidationErrors [errorEmitter]="errorEmitter"></div>

    @if (mergeInProgress()) {
      <div
        class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
        style="background-color: rgba(255, 255, 255, 0.9); border-radius: 0.25rem; z-index: 1000"
      >
        <div class="text-center">
          <div class="spinner-border text-primary mb-3" role="status">
            <span class="visually-hidden">Merging...</span>
          </div>
          <p class="text-muted mb-0">Processing merge, please wait...</p>
        </div>
      </div>
    }
  </div>
  <div class="modal-footer d-flex justify-content-between">
    <button type="button" class="btn btn-secondary" (click)="onConfirm(false)" [disabled]="mergeInProgress()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="onConfirm(true)"
      [disabled]="confirmationInputEnteredIncorrectly() || mergeConflictsExist || mergeInProgress()"
    >
      Confirm
    </button>
  </div>
</div>
